import React from 'react';
import { WifiOff, RotateCw } from 'lucide-react';

// Shown when the multiplayer server stays unreachable: clear message + "Riprova".
export const ConnectionProblem = ({ onRetry, compact = false }) => (
  <div
    className={`w-full flex flex-col items-center gap-3 rounded-2xl bg-black/40 border border-red-400/40 text-center ${compact ? 'p-3' : 'p-4'}`}
    data-testid="connection-problem"
  >
    <div role="alert" className="flex items-center gap-2" data-testid="connection-problem-message">
      <WifiOff className="w-4 h-4 text-red-400 shrink-0" aria-hidden="true" />
      <p className="font-sans text-sm text-[#FDFBF7]">
        Server non raggiungibile. Controlla la connessione e riprova.
      </p>
    </div>
    <button
      type="button"
      onClick={onRetry}
      data-testid="connection-retry-btn"
      className="flex items-center gap-2 rounded-full bg-[#D4AF37] text-[#14452F] font-sans font-bold px-6 py-2.5 transition-colors hover:bg-[#F2D675] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#F2D675]/60 active:translate-y-px"
    >
      <RotateCw className="w-4 h-4" aria-hidden="true" />
      Riprova
    </button>
  </div>
);
